export enum PortfolioSearch {
    NAME = 'NAME',
    ACCOUNT = 'ACCOUNT',
    VIN = 'VIN',
    MONTHS = 'MONTHS',
    PROGRAM = 'PROGRAM',
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
}
